module.exports = __webpack_public_path__ + "static/media/step-1-en.6458a066.jpg";